import gql from 'graphql-tag';

export const deleteProxy = gql`
  mutation DeleteTeamProxyV2($userID: String!, $proxyID: String!) {
    deleteTeamProxyV2(userID: $userID, proxyID: $proxyID) {
      success
      messageCode
    }
  }
`;

export const addProxy = gql`
  mutation AddTeamProxyV2(
    $userID: String!
    $proxyUsername: String!
    $sharedTeam: [String!]!
  ) {
    addTeamProxyV2(
      userID: $userID
      proxyUsername: $proxyUsername
      sharedTeam: $sharedTeam
    ) {
      success
      messageCode
    }
  }
`;

export const deleteProxyNotification = gql`
  mutation DeleteProxyNotificationV2(
    $userID: String!
    $relatedUserID: [String!]!
  ) {
    deleteProxyNotificationV2(userID: $userID, relatedUserID: $relatedUserID)
  }
`;
